<div class="container-distribution" nz-row [nzGutter]="[30, 30]">


  <div class="d-flex justify-content-start align-items-center tw-w-full tw-mt-4">
    <nz-select class="select-strategy" [(ngModel)]="strategyName" nzBorderless (ngModelChange)="changeStrategy($event)" [nzDisabled]="readOnly || disabled"
      [nzCustomTemplate]="strategyCustomTemplate">
      <nz-option [nzValue]="macronutrientDistributionTypeEnum.SMAE" [nzLabel]="macronutrientDistributionTypeEnum.SMAE | getTranslateEnum:'macronutrientsDistribution'"></nz-option>
      <nz-option [nzValue]="macronutrientDistributionTypeEnum.OMS" [nzLabel]="macronutrientDistributionTypeEnum.OMS | getTranslateEnum:'macronutrientsDistribution'"></nz-option>
      <nz-option [nzValue]="macronutrientDistributionTypeEnum.MX" [nzLabel]="macronutrientDistributionTypeEnum.MX | getTranslateEnum:'macronutrientsDistribution'"></nz-option>
      <nz-option [nzValue]="macronutrientDistributionTypeEnum.DGA_USDA_HHS" [nzLabel]="macronutrientDistributionTypeEnum.DGA_USDA_HHS | getTranslateEnum:'macronutrientsDistribution'"></nz-option>
    </nz-select>

    <ng-template #strategyCustomTemplate let-selected>
      <div class="tw-flex tw-justify-end tw-gap-1.5 tw-mr-2">
        <p class="text-info">
          <i nz-icon nzType="control" nzTheme="outline"></i>
        </p>
        <p nz-typography nzEllipsis class="tw-w-full">
          {{ selected.nzLabel }}
        </p>
      </div>
    </ng-template>
  </div>

  <div class="text-info tw-w-full tw-pl-3 " *ngIf="this.getSmaeGrams">
    Calorías totales: <span class="tw-font-semibold total-calories">{{ this.getSmaeGrams.calories.toFixed(2) }} kcal</span>
  </div>

  <ng-container *ngIf="distributionStrategy">
    <div class="tw-pl-3 tw-mt-2">
      <p *ngIf="!readOnly" class="tw-w-max text-subtitle tw-rounded tw-p-1 tw-flex tw-cursor-pointer tw-gap-1 tw-items-center tw-bg-gray-50 tw-text-gray-700" nz-popover="" [nzPopoverPlacement]="'bottom'" [nzPopoverTitle]="''" [nzPopoverContent]="tplMarkMacros">
        <span nz-icon nzType="info-circle" nzTheme="outline"></span>
        <span>Marcar macronutrientes</span>
      </p>
      <ng-template #tplMarkMacros>
        <p class="text-subtitle pl-sm pr-sm tw-w-80">
          Puedes seleccionar los macronutrientes cuando quieras dejar fijo el valor buscado. Si marcas un macronutriente, este no será modificado al cambiar la distribución.
        </p>
      </ng-template>
    </div>
    <div *ngFor="let macro of distributionStrategy | defaultOrderKeyValue; index as i, let last = last" class="macro" nz-col nzXs="24">
      <label
        nz-checkbox
        [(ngModel)]="distributionStrategy[macro].block"
        [nzDisabled]="this.blockedMacros.length === 2 && !this.blockedMacros.includes(macro) || disabled"
        [class.hide-check]="readOnly"
        (ngModelChange)="onChangeBlock()"
        class="tw-w-full tw-relative block-macronutient-{{i}}">
        <div class="tw-flex tw-flex-col tw-items-start tw-relative tw-left-2"><!-- d-flex justify-content-between flex-col align-items-center tw-absolute tw-left-0 tw-bottom-0 tw-w-full -->
          <div class="macro-header">
            <div class="tw-flex tw-items-center macronutrient-name">
              <img loading="lazy" [src]="'./../../../assets/images/icons/' + distributionStrategy[macro].icon" alt="">
              <div class="macro-name d-flex align-items-center">
                <i class="icon-lock" *ngIf="distributionStrategy[macro].block" nz-icon nzType="lock" nzTheme="outline"
                   nz-popover="" nzPopoverTitle="" nzPopoverContent="Macronutriente bloqueado"></i>
                <p class="tw-text-gray-700 tw-text-xs truncate">
                  {{distributionStrategy[macro].title}} <!--| <span class="tw-font-bold">{{distributionStrategy[macro].value}}%</span>-->
                </p>
              </div>
            </div>
<!--            <div class="tw-flex tw-items-center" *ngIf="patientId && patientWeight">-->
<!--              <p class="tw-text-gray-600 text-xs">{{  <span>g/kg</span> del paciente</p>-->
<!--            </div>-->
          </div>
          <div class="container-tags">

            <div class="tag-item" *ngIf="nutritionalPropertiesMealPlan">
              <p class="tw-text-gray-700 tw-text-xs">{{ nutritionalPropertiesMealPlan[macro | getTranslateEnum:'macronutrients']?.toFixed(2) }} <span>g</span></p>
              <p class="title">Total</p>
            </div>

            <div class="tag-item">
              <p class="tw-text-gray-700 tw-text-xs">{{ distributionStrategy[macro].grams }} <span>g</span></p>
              <p class="title">Total por periodo</p>
            </div>

            <div class="tag-item" *ngIf="distributionStrategy[macro].type === 'percentage'">
              <p class="tw-text-gray-700 tw-text-xs">
                {{ distributionStrategy[macro].reference.minimum + (distributionStrategy[macro].reference.maximum ? ' - ' +
                distributionStrategy[macro].reference.maximum : '') }} <span>%</span>
                <i *ngIf="distributionStrategy[macro].response.messageReferenceValue" class="icon-warning-distribution" nz-icon nzType="info-circle" nzTheme="outline"
                   nz-popover="" nzPopoverPlacement="topLeft" nzPopoverTitle="" [nzPopoverContent]="distributionStrategy[macro].response.messageReferenceValue"></i>
              </p>
              <p class="title">Referencia</p>
            </div>

            <div class="tag-item" *ngIf="distributionStrategy[macro].type === 'grams'">
              <p class="tw-text-gray-700 tw-text-xs">
                {{ distributionStrategy[macro].reference ?? '' }} <span>g</span>
                <i *ngIf="distributionStrategy[macro].response.messageReferenceValue" class="icon-warning-distribution" nz-icon nzType="info-circle" nzTheme="outline"
                   nz-popover="" nzPopoverPlacement="topLeft" nzPopoverTitle="" [nzPopoverContent]="distributionStrategy[macro].response.messageReferenceValue"></i>
              </p>
              <p class="title">Referencia</p>
            </div>

            <div class="tag-item">
              <p class="tw-text-gray-700 tw-text-xs">
                {{ distributionStrategy[macro].defaultValue || 0 }} <span>%</span>
                <i *ngIf="distributionStrategy[macro].response.messageChoiceValue" class="icon-warning-distribution" nz-icon nzType="info-circle" nzTheme="outline"
                   nz-popover="" nzPopoverPlacement="topLeft" nzPopoverTitle="" [nzPopoverContent]="distributionStrategy[macro].response.messageChoiceValue"></i>
              </p>
              <p class="title">Valor actual</p>
            </div>

            <div class="tag-item" *ngIf="this.getSmaeGrams && macro !== 'fiber'">
              <p class="tw-text-gray-700 tw-text-xs">
                {{ this.getSmaeGrams ? this.getSmaeGrams[macro] : '-' }}
              </p>
              <p class="title">Gramos</p>
            </div>

          </div>
        </div>
      </label>
      <ng-container *ngIf="!readOnly">
        <p class="text-info-bold-xs mt-sm">Porcentaje</p>
        <div class="d-flex align-items-center slider-macronutrient-distribution-{{i}}">
          <nz-slider [(ngModel)]="distributionStrategy[macro].defaultValue"
                     [nzMin]="0"
                     [nzMax]="100"
                     [nzStep]="1"
                     [nzMarks]="marks"
                     [nzTooltipVisible]="'never'"
                     [nzDisabled]="disabled"
                     class="mr-xs tw-w-full "
                     (ngModelChange)="onChangePercentage(macro)"></nz-slider>
          <nz-input-number [(ngModel)]="distributionStrategy[macro].defaultValue" [nzSize]="'small'" [nzMin]="0" [nzMax]="100"
                           [nzStep]="1"
                           [nzDisabled]="disabled"
                           style="max-width:75px;"
                           (ngModelChange)="onChangePercentage(macro)"
                           [nzFormatter]="formatterPercent"
                           [nzParser]="parserPercent"></nz-input-number>
        </div>
      </ng-container>
      <div class="tw-flex tw-flex-col md:tw-flex-row tw-justify-start tw-mt-3 tw-gap-2" *ngIf="patientId && patientWeight">
        <div class="data-info tw-flex tw-items-start tw-bg-gray-50 tw-rounded tw-p-2 tw-w-full md:tw-w-1/2">
          <img src="./assets/images/icons/icons8-healthy-food-100.png" alt="" class="tw-w-8 tw-mr-2">
          <div class="">
            <p class="tw-text-gray-600 tw-text-xs">Valor actual</p>
            <p class="tw-text-gray-600 tw-font-semibold tw-text-xs">{{ (nutritionalPropertiesMealPlan[macro | getTranslateEnum:'macronutrients'] / this.patientWeight)?.toFixed(2) }} g/kg del paciente</p>
          </div>
        </div>

        <div class="data-info tw-flex tw-items-start tw-bg-gray-50 tw-rounded tw-p-2 tw-w-full md:tw-w-1/2" *ngIf="this.getSmaeGrams">
          <img src="./assets/images/icons/icons8-account-100-2.png" alt="" class="tw-w-8 tw-mr-2">
          <div class="">
            <p class="tw-text-gray-600 tw-text-xs">Meta SMAE</p>
            <p class="tw-text-gray-600 tw-font-semibold tw-text-xs">{{ (this.getSmaeGrams[macro] / this.patientWeight)?.toFixed(2) }} g/kg del paciente</p>
          </div>
        </div>
      </div>
      <nz-divider style="margin: 30px 0 0 0;" *ngIf="!last"></nz-divider>
    </div>
  </ng-container>
</div>

<!--
  metodo 1 para distribucion
  (ngModelChange)="onChangePercentage(macro)"

  metodo 2 para distribucion
  (ngModelChange)="onChangePercentageIndex(i)"
 -->
